<!-- eslint-disable prettier/prettier -->
<template>
  <div
    class="gantt-elastic__header"
    :style="{ ...style['header'] }"
    :key="$i18n.locale"
  >
    <div
      class="gantt-elastic__header-title"
      :style="{ ...style['header-title'] }"
    ></div>
    <div
      class="gantt-elastic__header-options"
      :style="{ ...style['header-options'] }"
    >
      <button
        class="gantt-elastic__header-btn-recenter"
        :style="{ ...style['header-btn-recenter'] }"
        @click.prevent="recenterPosition"
      >
        {{ opts.locale.Now }}
      </button>
      <label
        class="gantt-elastic__header-label"
        :style="{ ...style['header-label'] }"
      >
        {{ opts.locale["X-Scale"] }}
        <div
          class="gantt-elastic__header-slider-wrapper"
          :style="{ ...style['header-slider-wrapper'] }"
        >
          <vue-slider
            class="gantt-elastic__header-slider"
            tooltip="none"
            :style="{ ...style['header-slider'] }"
            :process-style="{ ...style['header-slider--process'] }"
            :slider-style="{ ...style['header-slider--slider'] }"
            v-model="scale"
            :max="24"
            :min="2"
            width="100px"
          ></vue-slider>
        </div>
      </label>
      <label
        class="gantt-elastic__header-label"
        :style="{ ...style['header-label'] }"
      >
        {{ opts.locale["Y-Scale"] }}
        <div
          class="gantt-elastic__header-slider-wrapper"
          :style="{ ...style['header-slider-wrapper'] }"
        >
          <vue-slider
            class="gantt-elastic__header-slider"
            tooltip="none"
            :style="{ ...style['header-slider'] }"
            :process-style="{ ...style['header-slider--process'] }"
            :slider-style="{ ...style['header-slider--slider'] }"
            v-model="height"
            :max="100"
            :min="7"
            width="100px"
          ></vue-slider>
        </div>
      </label>
      <label
        class="gantt-elastic__header-label"
        :style="{ ...style['header-label'] }"
      >
        {{ opts.locale["Before/After"] }}
        <div
          class="gantt-elastic__header-slider-wrapper"
          :style="{ ...style['header-slider-wrapper'] }"
        >
          <vue-slider
            class="gantt-elastic__header-slider"
            tooltip="none"
            :style="{ ...style['header-slider'] }"
            :process-style="{ ...style['header-slider--process'] }"
            :slider-style="{ ...style['header-slider--slider'] }"
            v-model="scope"
            :max="31"
            :min="0"
            width="100px"
          ></vue-slider>
        </div>
      </label>
      <label
        class="gantt-elastic__header-label"
        :style="{ ...style['header-label'] }"
      >
        {{ opts.locale["Task list width"] }}
        <div
          class="gantt-elastic__header-slider-wrapper"
          :style="{ ...style['header-slider-wrapper'] }"
        >
          <vue-slider
            class="gantt-elastic__header-slider"
            tooltip="none"
            :style="{ ...style['header-slider'] }"
            :process-style="{ ...style['header-slider--process'] }"
            :slider-style="{ ...style['header-slider--slider'] }"
            v-model="divider"
            :max="100"
            :min="0"
            width="100px"
          ></vue-slider>
        </div>
      </label>
      <label
        class="gantt-elastic__header-task-list-switch--wrapper"
        :style="{ ...style['header-task-list-switch--label'] }"
      >
        <switches
          class="gantt-elastic__header-task-list-switch"
          :style="{ ...style['header-task-list-switch'] }"
          v-model="root.state.options.taskList.display"
        ></switches>
        {{ opts.locale["Display task list"] }}
      </label>
    </div>
  </div>
</template>
<!-- eslint-disable prettier/prettier -->
<script>
import vueSlider from "vue-slider-component"
import "vue-slider-component/theme/default.css"
import Switches from "vue-switches"


export default {
  name: "GanttHeader",
  components: {
    vueSlider,
    Switches
  },
  props: ["options", "dynamicStyle"],
  inject: ["root"],
  data() {
    return {
      scaleTimeoutId: null,
      firstScale: false,
      // localScale: 0,
      localScale: 9,
      localHeight: 0,
      localBefore: 0,
      localPercent: 0,
      sliderOptions: {
        xScale: {
          value: 0
        }
      },
      style: {},
      opts: {}
    };
  },
  created() {
    // this.localScale = this.root.state.options.times.timeZoom;
    // this.localScale = 5;
    this.localHeight = this.root.state.options.row.height;
    this.localBefore = this.root.state.options.scope.before;
    this.localPercent = this.root.state.options.taskList.percent;
    this.sliderOptions.xScale.value = this.localScale ,
    // this.sliderOptions.xScale.value = this.root.state.options.times.timeZoom;
    this.style = this.root.mergeDeep(
      {},
      {
        header: {
          margin: "0px auto",
          background: "#f3f5f747",
          padding: "10px",
          overflow: "hidden",
          clear: "both",
          display: "flex",
          "justify-content": "space-between",
          "font-family": "Manrope, sans-serif" 
        },
        "header-title": { float: "left", "font-family": "Manrope, sans-serif" },
        "header-options": { float: "right", "font-family": "Manrope, sans-serif"  },
        "header-btn-recenter": {
          background: "#004de5",
          border: "none",
          outline: "none",
          cursor: "pointer",
          color: "white",
          "border-radius": "3px",
          "margin-right": "27px",
          "font-size": "16px",
          padding: "8px 12px",
          "font-family": "Manrope, sans-serif" 
        },
        "header-slider": {
          "box-sizing": "content-box",
          "font-family": "Manrope, sans-serif" 
        },
        "header-slider-wrapper": {
          display: "inline-block",
          "vertical-align": "middle",
          "font-family": "Manrope, sans-serif" 
        },
        "header-slider--slider": { "box-sizing": "content-box", "font-family": "Manrope, sans-serif"  },
        "header-slider--process": { "box-sizing": "content-box", "font-family": "Manrope, sans-serif"  },
        "header-task-list-switch--label": { "box-sizing": "content-box", "font-family": "Manrope, sans-serif"  },
        "header-task-list-switch": {
          margin: "0px 15px",
          "vertical-align": "middle",
          "font-family": "Manrope, sans-serif" 
        },
        "header-label": {}
      },
      this.dynamicStyle
    );
    this.opts = this.root.mergeDeep(
      {},
      this.options,
      {
        title: {
          label: "gantt-elastic-01",
          html: false
        },
        locale: {
          Now: this.$t("views.gantt.now"),
          "X-Scale": this.$t("views.gantt.zoom_x"),
          "Y-Scale": this.$t("views.gantt.zoom_y"),
          "Task list width": this.$t("views.gantt.expand"),
          "Before/After": this.$t("views.gantt.task_list"),
          "Display task list": this.$t("views.gantt.task_list")
        }
      }
    );
    this.setScale(this.localScale);
  },
  methods: {
    
    getImage() {
      this.root.getImage("image/png").then(imgB64 => {
        const link = document.createElement("a");
        link.href = imgB64;
        link.download = "gantt-elastic.png";
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      });
    },
    recenterPosition() {
      this.root.$emit("recenterPosition");
    },
    setScale(value) {
      if (this.scaleTimeoutId !== null) {
        clearTimeout(this.scaleTimeoutId);
        this.scaleTimeoutId = null;
      }
      // debouncing
      if (this.firstScale) {
        this.scaleTimeoutId = setTimeout(() => {
          this.root.$emit("times-timeZoom-change", value);
          this.scaleTimeoutId = null;
        }, 50);
      } else {
        this.root.$emit("times-timeZoom-change", value);
        this.firstScale = true;
      }
    },
    updateTranslations() {
      this.opts = this.root.mergeDeep({}, this.options, this.defaultOptions);
    }
  },
  computed: {
    
    beforeOptionsIsComponent() {
      const headerSlot = this.options.slots.header;
      if (
        typeof headerSlot.beforeOptions === "object" &&
        !Array.isArray(headerSlot.beforeOptions)
      ) {
        return true;
      }
      return false;
    },
    beforeOptionsIsHtml() {
      if (typeof this.options.slots.header.beforeOptions === "string") {
        return true;
      }
      return false;
    },
    scale: {
      get() {
        return this.localScale;
      },
      set(value) {
        this.localScale = Number(value);
        this.setScale(this.localScale);
      }
    },
    height: {
      get() {
        return this.localHeight;
      },
      set(value) {
        this.localHeight = Number(value);
        this.root.$emit("row-height-change", Number(value));
      }
    },
    scope: {
      get() {
        return this.localBefore;
      },
      set(value) {
        this.localBefore = Number(value);
        this.root.$emit("scope-change", Number(value));
      }
    },
    divider: {
      get() {
        return this.localPercent;
      },
      set(value) {
        this.localPercent = Number(value);
        this.root.$emit("taskList-width-change", Number(value));
      }
    },
    defaultStyle() {
      return {
        header: {
          margin: "0px auto",
          background: "#f3f5f747",
          padding: "10px",
          overflow: "hidden",
          clear: "both",
          display: "flex",
          "justify-content": "space-between",
          "font-family": "Manrope, sans-serif" 
        }
        // ... (le reste du style)
      };
    },
    defaultOptions() {
      return {
        title: {
          label: "gantt-elastic-01",
          html: false
        },
        locale: {
          Now: this.$t("views.gantt.now"),
          "X-Scale": this.$t("views.gantt.zoom_x"),
          "Y-Scale": this.$t("views.gantt.zoom_y"),
          "Task list width": this.$t("views.gantt.expand"),
          "Before/After": this.$t("views.gantt.task_list"),
          "Display task list": this.$t("views.gantt.task_list")
        }
      };
    }
  },
  watch: {
    "$i18n.locale": function (newLocale) {
      // Mettez à jour les traductions ou tout autre traitement nécessaire
      this.updateTranslations();
    }
  }
};
</script>
